
(function ($, Drupal) {

  // for basic content paragraphs with the top overlap, set z-index on turtles
  if ($('.paragraph--type--basic-content .row__top-overlap').length > 0) {
    var turtle_paragraph = $('.paragraph--type--basic-content .row__top-overlap').parent().siblings('.background-wrapper').find('.turtle');
    if (turtle_paragraph.length > 0) {
      $(turtle_paragraph).css('z-index', '4');

      // add z-index to all other paragraphs in that background container
      var child_paragraphs = $('.paragraph').not($('.paragraph--type--basic-content').has('.row__top-overlap'));
      if ($(child_paragraphs).siblings('.background-wrapper').find('.turtle').length > 0) {
        $(child_paragraphs).css('z-index', '5');
      }
    }
  }

  // for nodes with fake basic content paragraphs, set z-index on turtles
  if ($('.node--turtle-background .row').length > 0) {
    var turtle_node = $('.node--turtle-background .row').parent().siblings('.background-wrapper').find('.turtle');
    if (turtle_node.length > 0) {
      $(turtle_node).css('z-index', '4');

      // add z-index to all other paragraphs in that background container
      var node_child_paragraphs = $('.paragraph').not($('.paragraph--type--basic-content').has('.row__top-overlap'));
      if ($(node_child_paragraphs).siblings('.background-wrapper').find('.turtle').length > 0) {
        $(node_child_paragraphs).css('z-index', '5');
      }
    }
  }

  // this function repeats the base turtle pattern based on the number provided
  var addTurtles = function(turtles, parent) {
    for (let i = 0; i < turtles; i++) {
      var turtlesClone = $(parent).find('.turtles-wrapper').clone();
      $(turtlesClone).removeClass('turtles-wrapper').addClass('turtles-wrapper--clone');
      $(turtlesClone).appendTo($(parent).find('.background-wrapper'));
    }
  };

  // for each turtle background container on the page
  var turtleBackgrounds = $('.paragraph--type--background-container .turtles-wrapper');
  for (let i = 0; i < turtleBackgrounds.length; i++) {
    // calculate how many times to repeat the turtle pattern based on background container height
    var parentBackground = $(turtleBackgrounds[i]).closest('.paragraph--type--background-container');
    var containerHeight = $(parentBackground).height() / 500;
    var numTurtles = Math.floor(containerHeight);
    if (numTurtles > 0) {
      addTurtles(numTurtles, parentBackground);
    }
  }
}(jQuery, Drupal));